import React, { FC } from 'react';
import useTranslation from 'ia-react-core/~/hooks/useTranslation';

const year = new Date().getFullYear();
export interface CorpoCopyrightProps {}

/**
 * @since 0.18.0
 */
const CorpoCopyright: FC<CorpoCopyrightProps> = () => {
  const { t } = useTranslation('Core.CorpoCopyright');

  return (
    <>{t('copyright', { year })}</>
  );
};

/**
 * @component
 */
export default CorpoCopyright;
